import {
  addAdminGroup,
  delAdminGroup,
  editAdminGroup,
  getAdminGroupList,
  getAdminList,
  listGroupUsers,
} from '@/services/user/UserController';
import { ActionType } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export default () => {
  const actionRef = useRef<ActionType>();
  const [loading, setLoading] = useState(false);

  // 更新用户组信息
  const updateAdminGroup = useRequest(editAdminGroup, {
    manual: true,
  });
  // 删除用户组信息
  const deleteAdminGroup = useRequest(delAdminGroup, {
    manual: true,
  });
  // 删除用户组信息
  const insertAdminGroup = useRequest(addAdminGroup, {
    manual: true,
  });

  // 获取用户组已选中用户列表
  const fetchAdminGroupList = useRequest(getAdminGroupList, {
    manual: true,
  });

  // 获取用户组列表
  const fetchListGroupUsers = useRequest(listGroupUsers, {
    manual: true,
  });
  // 获取用户列表
  const fetchAdminList = useRequest(getAdminList, {
    manual: true,
  });
  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [
    updateAdminGroup,
    insertAdminGroup,
    deleteAdminGroup,
    fetchAdminGroupList,
    fetchListGroupUsers,
    fetchAdminList,
  ];

  /**
   * 监听处理loading状态
   */
  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 0);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [updateAdminGroup, deleteAdminGroup, insertAdminGroup, fetchAdminGroupList, fetchListGroupUsers, fetchAdminList]);

  return {
    loading,
    setLoading,
    actionRef,
    fetchAdminGroupList,
    insertAdminGroup,
    updateAdminGroup,
    deleteAdminGroup,
    fetchListGroupUsers,
    fetchAdminList,
  };
};
